<span [ngClass]="['circle', rateIdIdToClassMap.get(rateTypeId) ?? 'unknown']"></span><span [title]="labelText" class="rate-label">{{ labelText }}</span
><ng-content></ng-content>
